import React, { useState } from 'react';
import './WhatsAppBtn.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeadset, faChevronLeft, faX } from '@fortawesome/free-solid-svg-icons';

const faqContent = {
    verificados: {
        title: '✅ Proveedores verificados',
        body: (
            <>
                <p>En <strong>MINYMOL</strong> solo activamos proveedores verificados. Cada uno debe cumplir con:</p>
                <ul>
                    <li>📄 Documentación legal vigente (RUT, cédula, cámara de comercio)</li>
                    <li>🏬 Evidencia de tener un establecimiento comercial (punto de venta o fábrica)</li>
                    <li>📆 Antigüedad mínima de 2 años en el mercado</li>
                </ul>
                <p>Así garantizamos que haces pedidos a proveedores reales, formales y con experiencia comprobada.</p>
            </>
        ),
        video: null, // Puedes poner un link de YouTube aquí si quieres: 'https://www.youtube.com/embed/VIDEO_ID'
    },
    // Puedes seguir agregando más respuestas tipo FAQ aquí...
};

const WhatsAppBtn = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [step, setStep] = useState('inicio');
    const [direction, setDirection] = useState('forward');

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
        setStep('inicio');
        setDirection('forward');
    };

    const handleStepChange = (nextStep) => {
        setDirection('forward');
        setStep(nextStep);
    };

    const handleBack = (prevStep = 'inicio') => {
        setDirection('backward');
        setStep(prevStep);
    };

    const whatsappLinks = {
        ayudaProveedor: 'https://wa.me/573169277199?text=Hola%2C+necesito+ayuda+para+convertirme+en+proveedor+de+Minymol.',
        hablarAgente: 'https://wa.me/573169277199?text=Hola%2C+quiero+hablar+con+un+agente+de+Minymol.',
    };

    const renderContent = () => {
        if (step === 'inicio') {
            return (
                <>
                    <button className="modal-btn" onClick={() => handleStepChange('proveedor')}>Soy Proveedor</button>
                    <button className="modal-btn" onClick={() => handleStepChange('comerciante')}>Soy Comerciante</button>
                </>
            );
        }

        if (step === 'proveedor') {
            return (
                <>
                    <button className="back-btn" onClick={() => handleBack()}>
                        <FontAwesomeIcon icon={faChevronLeft} /> Atrás
                    </button>
                    <a className="modal-btn" href="/solicitud-proveedor">
                        Quiero ser proveedor
                    </a>
                    <a className="modal-btn whatsapp" href={whatsappLinks.ayudaProveedor} target="_blank" rel="noopener noreferrer">
                        Necesito ayuda
                    </a>
                </>
            );
        }

        if (step === 'comerciante') {
            return (
                <>
                    <button className="back-btn" onClick={() => handleBack()}>
                        <FontAwesomeIcon icon={faChevronLeft} /> Atrás
                    </button>
                    <button className="modal-btn" disabled style={{ opacity: 0.6 }}>¿Cómo me registro en la plataforma?</button>
                    <button className="modal-btn" disabled style={{ opacity: 0.6 }}>¿Cómo hacer un pedido?</button>
                    <button className="modal-btn" disabled style={{ opacity: 0.6 }}>¿Cómo es el método de pago?</button>
                    <button className="modal-btn" onClick={() => handleStepChange('verificados')}>
                        ¿Los proveedores están verificados?
                    </button>
                    <a className="modal-btn whatsapp" href={whatsappLinks.hablarAgente} target="_blank" rel="noopener noreferrer">
                        Hablar con un agente
                    </a>
                </>
            );
        }

        if (faqContent[step]) {
            const { title, body, video } = faqContent[step];
            return (
                <>
                    <button className="back-btn" onClick={() => handleBack('comerciante')}>
                        <FontAwesomeIcon icon={faChevronLeft} /> Atrás
                    </button>
                    <div className="faq-step">
                        <h3>{title}</h3>
                        <div className="faq-body">{body}</div>
                        {video && (
                            <div className="faq-video">
                                <iframe
                                    width="100%"
                                    height="200"
                                    src={video}
                                    title="Video tutorial"
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                ></iframe>
                            </div>
                        )}
                    </div>
                </>
            );
        }

        return null;
    };

    return (
        <div className="whatsapp-btn-container">
            <button className="whatsapp-btn" onClick={toggleModal}>
                <FontAwesomeIcon icon={isModalOpen ? faX : faHeadset} />
            </button>

            <div className={`modal-bubble ${isModalOpen ? 'open' : 'close'}`}>
                <div className={`modal-content ${direction === 'forward' ? 'slide-left' : 'slide-right'}`}>
                    {renderContent()}
                </div>
            </div>
        </div>
    );
};

export default WhatsAppBtn;
